export default "__VITE_ASSET__KEVG9hPO__"